const API_AUTH = `${window.location.protocol}//${window.location.host}/auth`
// const API_AUTH = 'https://sistema.stnbarbearia.com.br/auth'

export default API_AUTH
